import React from 'react';
import PropTypes from 'prop-types';
import Absolute from './Absolute';
import PanelContent from './PanelContent';
import OverlayWrapper from './OverlayWrapper';
import { Text } from '../common';
import { Content } from '../MiniControl/styles';
import RestorePlayer from '../MiniControl/RestorePlayer/RestorePlayer';
import Close from '../MiniControl/Close/Close';

function ParentalControlOverlay(props) {
  const {
    mini,
  } = props;

  let content;
  if (mini) {
    content = (
      <PanelContent centered>
        <Absolute top="0.7em" right="0.7em">
          <Close />
        </Absolute>

        <Content>
          <Text
            id="parentalControl.enterPin"
            fontSize="medium"
            color="light"
            bold
          />
        </Content>

        <Content>
          <RestorePlayer withMargin={false} />
        </Content>
      </PanelContent>
    );
  } else {
    content = (
      <PanelContent centered>
        <Text
          id="parentalControl.enterPin"
          letterSpacing="0.14em"
          fontSize="sectionHeading"
          color="light"
        />
      </PanelContent>
    );
  }

  return (
    <OverlayWrapper>
      {content}
    </OverlayWrapper>
  );
}

ParentalControlOverlay.propTypes = {
  mini: PropTypes.bool,
};

export default React.memo(ParentalControlOverlay);
